import React, { useContext } from 'react';
import classnames from 'classnames';
import { ActionBarContext } from '../ActionBarContext';
import ActionBarStrip from '../_partials/ActionBarStrip';
import SecondaryActionBarIcons from '../_partials/SecondaryActionBarIcons';
import PrimaryActionBarDesktop from '../ActionBarDesktop/PrimaryActionBarDesktop';
import s from '../ActionBarDesktop/ActionBarDesktop.scss';
var ActionBarLiterature = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var isSecondaryBar = useContext(ActionBarContext) === 'secondary';
    var className = classnames(s['root'], s['literature'], isSecondaryBar && s['secondary']);
    return isSecondaryBar ? (React.createElement(ActionBarStrip, { className: className },
        React.createElement(SecondaryActionBarIcons, { deviation: deviation, isOwner: isOwner, className: s['icons-wrapper'] }))) : (React.createElement(PrimaryActionBarDesktop, { className: className, deviation: deviation, isOwner: isOwner, disableBadgeLabel: true }));
};
export default ActionBarLiterature;
//# sourceMappingURL=ActionBarLiterature.js.map